import { render, staticRenderFns } from "./saveGroup.vue?vue&type=template&id=4fd3934e&"
import script from "./saveGroup.vue?vue&type=script&lang=js&"
export * from "./saveGroup.vue?vue&type=script&lang=js&"
import style0 from "./saveGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports